import { isValidDict } from "./validator";

export const SESSION_USER_KEY = "customer"

// Flag to prevent multiple simultaneous logout calls
let isLoggingOut = false;

export function saveUser(user) {
    if (isValidDict(user)) {
        sessionStorage.setItem(SESSION_USER_KEY, JSON.stringify(user));
    }
}

export function getUser() {
    let user = sessionStorage.getItem(SESSION_USER_KEY);
    if (user) {
        console.log(user)
        return JSON.parse(user)
    }
    return null
}

/**
 * Centralized logout function - clears user data from sessionStorage
 * and optionally redirects to login page
 */
export function logoutUser() {
    if (isLoggingOut) {
        return false; // Already logging out, prevent duplicate calls
    }
    isLoggingOut = true;

    // Clear the correct sessionStorage key
    sessionStorage.removeItem(SESSION_USER_KEY);

    // Reset the flag after a short delay to allow future logouts
    setTimeout(() => {
        isLoggingOut = false;
    }, 1000);

    return true;
}

/**
 * Check if user is logged out (used to prevent redundant logout calls)
 */
export function isLoggedOut() {
    return !getUser();
}